/* eslint-disable dot-notation */
import { useEffect, useState } from 'react';
import { execJsInSdk, logError } from '../integration-utils';
export var getUserAgent = function () { return window.navigator.userAgent; };
export function useGetHeaders(isWebviewVisible) {
    var _a = useState([]), headers = _a[0], setHeaders = _a[1];
    useEffect(function () {
        if (!isWebviewVisible)
            return;
        void execJsInSdk(getUserAgent, 'get_user_agent')
            .then(function (x) { return setHeaders(headers.concat({ name: 'User-Agent', value: x })); })
            .catch(function (e) {
            return logError({ errorName: 'user_agent_error', errorObject: e });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isWebviewVisible]);
    return headers;
}
